import Ajax from '../core/Ajax';
import Cookies from '../library/Cookies';

export default class Station {
	constructor() {
		this.el = document.querySelector('.topbar__stations');
		this.zipcodeForm = this.el.querySelector('.topbar__zipcode-form');
		this.zipcodeInput = this.el.querySelector('.topbar__zipcode-form-input');
		this.zipcodeSubmitButton = this.el.querySelector('.topbar__zipcode-form-submit');
		this.previousZipCodeSubmitted = null;
		this.error = this.el.querySelector('.topbar__zipcode-error');
		this.airTime = this.el.querySelector('.topbar__air-time');
		this.cookies = new Cookies();

		this.onSubmitZipCodeForm = this.onSubmitZipCodeForm.bind(this);
		this.zipcodeForm.addEventListener('submit', this.onSubmitZipCodeForm);

		// Get station from cookie
		const stationCookie = this.cookies.get('vb_station');

		if (stationCookie) {
			const cookie = JSON.parse(stationCookie);

			if (cookie.airTimes) {
				this.updateStationUI(cookie);
			} else {
				this.setDefaultStation();
			}
		} else {
			// Get station by IP
			this.getStationFromApi();
		}
	}

	getStationFromApi(data = {}) {
		const { zipcode } = data;
		const params = {};

		if (zipcode) {
			params.zipcode = zipcode;
		}

		new Ajax({
			_ajaxURL: '/station-lookup.php',
			method: 'GET',
			params,
			callback: (ajax) => {
				if (ajax.ok && ajax.response && !ajax.response.error) {
					console.log(`Set station by IP (Zip Code: ${ajax.response.zipcode} | Title: ${ajax.response.title} | Air Times: ${ajax.response.airTimes})`);

					// Save station to cookie
					this.saveStationCookie(ajax.response);

					// Update station UI
					this.updateStationUI(ajax.response);
				} else {
					console.warn(`Could not get station by IP${vb.defaultStation ? ', fallback to default station' : ''}`);

					// Fallback to default station
					this.setDefaultStation();
				}

				this.el.classList.add('topbar__stations--loaded');
				this.zipcodeSubmitButton.removeAttribute('disabled');
			},
		});
	}

	onClickChangeZipcode(e) {
		this.el.classList.add('topbar__stations--form');
		this.error.classList.remove('topbar__zipcode-error--visible');
	}

	onClickCancel(e) {
		this.el.classList.remove('topbar__stations--form');
	}

	onSubmitZipCodeForm(e) {
		e.preventDefault();

		const zipcode = this.zipcodeInput.value;

		if (!zipcode || !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode)) {
			this.error.classList.add('topbar__zipcode-error--visible');
			return;
		} else if (this.previousZipCodeSubmitted !== null && this.previousZipCodeSubmitted === zipcode) {
			return;
		}

		this.previousZipCodeSubmitted = zipcode;

		this.zipcodeSubmitButton.setAttribute('disabled', '');
		this.el.classList.remove('topbar__stations--loaded');
		this.el.classList.remove('topbar__stations--form');
		this.error.classList.remove('topbar__zipcode-error--visible');

		// Get station from API
		this.getStationFromApi({ zipcode });

		// new Ajax({
		// 	method: 'GET',
		// 	params: {
		// 		action: 'ajax_get_station_by_zipcode',
		// 		zipcode: this.zipcodeInput.value,
		// 	},
		// 	callback: (ajax) => {
		// 		if (ajax.ok && ajax.response && !ajax.response.error) {
		// 			console.log(`Set station from zip code (Zip Code: ${ajax.response.zipcode} | Title: ${ajax.response.title} | Air Times: ${ajax.response.airTimes})`);

		// 			// Save station to cookie
		// 			this.saveStationCookie(ajax.response);

		// 			// Update station UI
		// 			this.updateStationUI(ajax.response);
		// 		} else {
		// 			console.warn('Could not get station from zip code');
		// 		}

		// 		this.el.classList.add('topbar__stations--loaded');
		// 	},
		// });
	}

	saveStationCookie({ zipcode, title, airTimes }) {
		this.cookies.set(
			'vb_station',
			JSON.stringify({
				zipcode,
				title,
				airTimes,
			}),
			24,
		);
	}

	updateStationUI({ zipcode, airTimes }) {
		if (airTimes) {
			this.airTime.innerHTML = `<span class="topbar__tune-in-text">Tune in on</span> <span class="topbar__air-time-station">${airTimes}</span>`;
			
			if (this.changeZipcodeBtn) {
				if (!zipcode) {
					this.changeZipcodeBtn.textContent = this.changeZipcodeBtn.dataset.enterZipcodeText;
				} else {
					this.changeZipcodeBtn.textContent = this.changeZipcodeBtn.dataset.changeZipcodeText;
				}
			}
		} else {
			this.airTime.innerHTML = `<span class="topbar__air-time-station"></span>`;
		}
	}

	setDefaultStation() {
		if (!vb.defaultStation || vb.defaultStation.length === 0) {
			return;
		}

		console.log(`Set default station (Title: ${vb.defaultStation.title} | Air Times: ${vb.defaultStation.air_times})`);
		
		// Save station cookie
		this.saveStationCookie({
			title: vb.defaultStation.title,
			airTimes: vb.defaultStation.air_times,
		})

		// Update station UI
		this.updateStationUI({
			airTimes: vb.defaultStation.air_times,
		});
	}
}
